export function extractAndMergeOptions(options, defaultOptions) {
  // properties that also are in defaults are used to extract the options
  const properties = Object.keys(defaultOptions);
  // override the default values with the provided options
  return properties.reduce(
    (acc, key) => {
      if (options[key] != null) {
        return Object.assign(Object.assign({}, acc), { [key]: options[key] });
      }
      return acc;
    },
    Object.assign({}, defaultOptions),
  );
}
